import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  position: relative;
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const Content = styled.div`
  max-width: 1000px;
  width: 100%;
  padding: 25px;
  color: #333;
  font-family: "Raleway", sans-serif;
  font-size: 16px;
  line-height: 1.6;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

  h2 {
    color: #0c2b6e;
    margin-top: 20px;
    font-size: 20px;
  }

  h3 {
    color: #0c2b6e;
    margin-top: 20px;
    font-size: 28px;
  }

  p,
  ul {
    margin: 10px 0;
  }

  ul {
    padding-left: 20px;
    list-style: disc;
  }

  strong {
    color: #0c2b6e;
  }

  em {
    color: #555;
  }

  @media (max-width: 768px) {
    padding: 20px;
    font-size: 17px;

    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 23px;
    }
  }
`;

export const ContinueButton = styled.button`
  background-color: #0c2b6e;
  color: #fff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  font-size: 16px;
  padding: 10px 18px;
  border: none;
  border-radius: 40px;
  cursor: pointer;
  box-shadow: 0px 4px 5px 1px rgba(0, 0, 0, 0.3);
  transition: background-color 0.2s ease-in-out;
  height: 55px;
  &:hover {
    background-color: #0a1f50;
  }

  @media (max-width: 768px) {
    padding: 8px 14px;
  }
`;

export const SkipButton = styled.button`
  position: fixed;
  bottom: 20px;
  box-shadow: 1px 4px 5px 1px rgba(0, 0, 0, 0.2);
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(241, 241, 241, 0.92);
  color: #0c2b6e;
  padding: 10px 15px;
  border: 1px solid #0c2b6e;
  border-radius: 20px;
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  z-index: 1000;
  opacity: 0.85;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row; /* Alinha os links horizontalmente */
  justify-content: center; /* Alinha os links ao centro */
  width: 100%;

  margin: 15px 0;
  align-items: center; /* Alinha os links verticalmente no centro */
  @media (max-width: 767px) {
    flex-direction: column; /* Coloca os links um abaixo do outro em telas pequenas */
    gap: 15px; /* Ajuste do espaçamento entre os links */
  }
`;

export const LinkLogin = styled.span`
  display: flex;
  align-items: center; /* Garante que o ícone e o texto fiquem alinhados verticalmente */
  justify-content: center;
  cursor: pointer;
  color: #0c2b6e;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 17px;
  text-decoration: underline;
  gap: 5px; /* Adiciona um espaço consistente entre o texto e o ícone */

  margin-top: 0; /* Ajustado para garantir que fiquem alinhados */

  span {
    display: flex;
    align-items: center; /* Alinha o ícone com o texto */
  }

  @media (max-width: 1330px) {
    font-size: 15px;

    gap: 4px; /* Ajuste o gap para dar um pouco de espaçamento entre o texto e o ícone */
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

export const LogoImage = styled.img`
  width: 220px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 150px;
  }
`;

export const Title = styled.h1`
  font-size: 35px;
  color: #0c2b6e;
  font-family: "Raleway", sans-serif;
  margin: 20px 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 29px;
  }
`;
